import React from "react";
import { useTranslation } from "react-i18next";
import { View } from "react-native";

import Subtitle from "@/components/Subtitle";
import TitleXl from "@/components/TitleXl";
import { generateTransfersRailChart } from "@/components/management/charts/Charts";

interface Props {
  data: any;
  width: number;
  isMobile: boolean;
}

export default function RailChart(props: Props) {
  const { t } = useTranslation();

  return (
    <View className="w-fit m-2 p-2 items-center">
      <View className="mb-2">
        <TitleXl text={t("management/transactions:charts.rail.titleout")} />
        <View className="mt-2">
          <Subtitle
            text={t("management/transactions:charts.rail.subtitleout")}
          />
        </View>
      </View>
      <View className="flex-col items-center">
        {generateTransfersRailChart(props.data, props.width, props.isMobile)}
      </View>
    </View>
  );
}
